import React, { useEffect, useState } from 'react'
import axios from 'axios'
import cx from 'classnames'

import { statusUrl } from 'utils/url'

import styles from './StatusBanner.module.css'

// Possible banner states:
// - null      -> nothing to show (status ok, or request silently failed)
// - 'error'   -> backend reports a problem, show the message to the user
// - 'invalid' -> the /status response is broken (HTTP 500 or malformed JSON),
//                shown distinctly so whoever maintains the status message
//                notices they made a mistake in the JSON
const StatusBanner = () => {
    const [variant, setVariant] = useState(null)
    const [message, setMessage] = useState('')

    useEffect(() => {
        let cancelled = false

        axios
            .get(statusUrl)
            .then(res => {
                if (cancelled) return

                const data = res.data

                if (data && data.status === 'ok') {
                    setVariant(null)
                } else if (data && data.status === 'error') {
                    setVariant('error')
                    setMessage(data.message || '')
                } else {
                    // Reached the backend, but the payload is not the expected shape.
                    setVariant('invalid')
                    setMessage('The status response has an invalid format (status missing or unknown).')
                }
            })
            .catch(err => {
                if (cancelled) return

                const httpStatus = err.response && err.response.status

                if (httpStatus >= 500) {
                    // Server-side error while serving /status -> the maintainer
                    // most likely broke the status JSON.
                    setVariant('invalid')
                    setMessage(`The status response could not be loaded (HTTP ${httpStatus}).`)
                } else {
                    // Network error, 404, backend down, etc. -> stay silent.
                    setVariant(null)
                }
            })

        return () => {
            cancelled = true
        }
    }, [])

    if (!variant) return null

    return (
        <div className={cx(styles.banner, styles[variant])} role="alert">
            {variant === 'invalid' && <span className={styles.label}>Invalid status response: </span>}
            {message}
        </div>
    )
}

export default StatusBanner
